import React from "react";

const ResumeEntry = props => {
  const { date, title, subtitle } = props;

  return (
    <div className="row mt">
      <div className="col-sm-4">
        <strong>{date}</strong>
      </div>
      <div className="col-sm-8">
        <h3>{title}</h3>
        <p>{subtitle}</p>
      </div>
    </div>
  );
};

export default ResumeEntry;



// WEBPACK FOOTER //
// ./src/components/Resume/ResumeEntry.js